import { render, staticRenderFns } from "./order-view-manager.vue?vue&type=template&id=4a860de3&scoped=true&"
import script from "./order-view-manager.ts?vue&type=script&lang=ts&"
export * from "./order-view-manager.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a860de3",
  null
  
)

export default component.exports